import { WithContext, Organization } from 'schema-dts';

import { StoreConfigQuery } from '@/fo/api/magento';

export const mapToJsonLd = (
  storeConfig: StoreConfigQuery['storeConfig']
): WithContext<Organization> => {
  const jsonLd: WithContext<Organization> = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: storeConfig?.store_name ?? '',
    url: process.env.APP_URL ?? '',
    image: `${process.env.API_MAGENTO_MEDIA_URL}/logo/${storeConfig?.header_logo_src}`,
    telephone: storeConfig?.store_telephone ?? '',
    address: {
      '@type': 'PostalAddress',
      streetAddress: storeConfig?.store_street ?? '',
      addressLocality: storeConfig?.store_city ?? '',
      addressRegion: storeConfig?.store_region ?? '',
      postalCode: storeConfig?.store_zip_code ?? '',
      addressCountry: storeConfig?.store_country ?? ''
    }
  };

  return jsonLd;
};
